import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SPINNER } from 'src/app/modules/shared/tokens/http-context.tokens';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InventoryService {

  private _inventoryItinerary = `${environment.inventory}/itineraries`;
  private _inventoryVehicles = `${environment.inventory}/tranfers`;

  private _inventoryapiUrl = `${environment.inventory}`;

  constructor(
    private _http : HttpClient,
  ) { }

  ////////////////////////////////
  // Inventory itinerary functions
  ////////////////////////////////

  // Get all default itinerary
  getAllInventoryItinerary(pageNumber:any, pageSize:any, token:any, searchValue:any, filters: any) : Observable<any>{
    const paginationSettings = {
      pageNumber: pageNumber || 1,
      pageSize: pageSize|| 10,
      search: searchValue,
      filters: filters
    }
    return this._http.post<any>(`${this._inventoryItinerary}`, paginationSettings);
  }
  // Delete itinerary
  deleteInventoryItinerary(id: any): Observable<any>{    
    return this._http.delete<any>(`${this._inventoryItinerary}/itinerary/${id}`);
  }

  // Get itinerary 
  getInventoryItinerary(id:any):Observable<any>{
    return this._http.get<any>(`${this._inventoryItinerary}/itinerary/${id}`)
  }

  // update inventory itinerary
  updateInventoryItinerary(id: any, formData: any){
    return this._http.put<any>(`${this._inventoryItinerary}/itinerary/${id}`, formData)
  }

  // add itinery details to inventory itinenry
  addInventoryItineraryDetails(formData: any): Observable<any>{
    return this._http.post<any>(`${this._inventoryItinerary}/additinerarydetails`, formData);
  }

  // add Route craft
  addInventoryRouteCraft(formData: any): Observable<any>{
    return this._http.post<any>(`${this._inventoryItinerary}/addroutecraft`, formData);
  }

  // Add inclusions and exclusions
  addInventoryInclusionsAndExclusions(formData: any): Observable<any>{
    return this._http.post<any>(`${this._inventoryItinerary}/addinclusionandexclusion`, formData);
  }

  // Add terms and conditions
  addInventoryTermsAndConditions(formData: any): Observable<any>{
    return this._http.post<any>(`${this._inventoryItinerary}/addtermsandcondition`, formData);
  }

  // Add canclelation policy
  addInventoryCancellationPolicy(formData: any): Observable<any>{
    return this._http.post<any>(`${this._inventoryItinerary}/addcancellationpolicy`, formData);
  }

  // Add important information
  addInventoryImportantInformation(formData: any): Observable<any>{
    return this._http.post<any>(`${this._inventoryItinerary}/addimportantinformation`, formData);
  }

  // Add Notes
  addInventoryNotes(formData: any): Observable<any>{
    return this._http.post<any>(`${this._inventoryItinerary}/addnotes`, formData);
  }

  // Get recommeneded itinerary
  getRecommendedItineraries(formData: any, type: string) {
    return this._http.post<any>(`${environment.inventory}/recommendedItineraries?type=${type}`, formData, {
      context: new HttpContext().set(SPINNER, false) // Passing flag
    });
  }

  // get all inventory images
  getAllImages(pageNumber:any, pageSize:any, token:any):Observable<any>{
    return this._http.get<any>(`${this._inventoryapiUrl}/images`);
  }

//addvehicle
  addInventoryVehicle(formData: any): Observable<any>{
    return this._http.post<any>(`${this._inventoryVehicles}/addtransfer`, formData);
  }

  deleteInventoryVehicle(transferId: any): Observable<any>{
    return this._http.delete<any>(`${this._inventoryVehicles}/tranfer/${transferId}`);
  }

  getInventoryVehicle(transferId: any): Observable<any>{
    return this._http.get<any>(`${this._inventoryVehicles}/tranfer/${transferId}`);
  }


  getAllVehicles(pageNumber:any,pageSize:any, searchValue:any,filters: any): Observable<any>{
    const paginationSettings = {
      pageNumber: pageNumber || 1,
      pageSize: pageSize|| 10,
      search: searchValue,
      filters: filters
    }
    return this._http.post<any>(`${this._inventoryVehicles}`,paginationSettings);
  }

  uploadTransfersImage(formData:any): Observable<any>{
    return this._http.post<any>(`${environment.inventory}/transfer/uploadimage`, formData);
  }

  getVehicleByLocation(location: any): Observable<any> {
    return this._http.get<any>(`${this._inventoryVehicles}/${location}`);
  }

  performBulkActions(req:any): Observable<any>{
    return this._http.put<any>(`${environment.inventory}/updateitinerarys`, req)
  }

  performBulkActionsForVehicles(req:any): Observable<any>{
    return this._http.put<any>(`${environment.inventory}/updatevehicles`, req)
  }

  
}
